import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from './Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region SHIPPING

function _Shipping(props) {
    const data = props.data || {};
    const blockProps = props.config && props.config.config && props.config.config.Block || {};
    let hasValue;
    if (blockProps.includeShippingZero || (!blockProps.includeShippingZero && data.Shipping != 0)) {
        hasValue = true;
    }
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const Shipping = withLabelTokenParsing(_Shipping, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.Shipping:
            if (data.ExchangeRate && data.ExchangeRate.Shipping != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Shipping, options);
            }
            break;
        case Token.Total.Shipping:
            if (data.Shipping != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.Shipping, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getCurrencyTokenConfig('Shipping', defaultValue, Token.Total.Shipping),
        Token.getWrappedTokenConfig('Shipping (Display Currency)', Token.DisplayCurrency.Shipping)
    ];
};
const TypeConfig = {
    panel: {
        block: () => LabelValueTypeConfig.panel.block(2, [{
            display: 'Display if shipping is 0',
            fullWidth: true,
            group: 'block',
            name: 'includeShippingZero',
            type: 'checkbox'
        }]),
        description: LabelValueTypeConfig.panel.description,
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: 'Shipping' })),
        style: LabelValueTypeConfig.panel.style,
        value: (data) => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.Shipping}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Shipping }))
    }
};

// #endregion SHIPPING

export {
    Shipping as Component,
    Tokens,
    TypeConfig
}